/**
 *
 * Qlist
 *
 */

import { mapActions } from 'vuex';
import $ from 'jquery';

import TrackerButton from '@/components/TrackerButton.vue';

import { QaMixin } from '@/mixins/QA/QA';
import { QaAskMixin } from '@/mixins/QA/QaAsk';
import { QaSendSmsNotificationMixin } from '@/mixins/Setting/QaSendSmsNotification';

export default {
  name: 'QaAskModal',

  mixins: [QaMixin, QaAskMixin, QaSendSmsNotificationMixin],

  components: {
    TrackerButton,
  },

  methods: {
    ...mapActions('Mixins/QA', {
      ma_doQuestionNew: 'doQuestionNew',
    }),

    ///
    openQaModal() {
      $(this.$refs.writeQuestion).modal('show');
    },

    ///
    async doPostQA() {
      await this.ma_doQuestionNew({
        tagIds: this.c_selectedTagsId, //idArr.length > 0 ? idArr : [26],
        qaTitle: this.qaTitle,
        qaContent: this.qaContent,
      });
    },

    ///
    doAfterPostQaSuccess() {
      this.$emit('qa-ask-posted');
    },

    ///
    closeQaModal() {
      $(this.$refs.writeQuestion).modal('hide');
    },
  },
};
